const thrashIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
</svg>
`
const minusIcon = `
<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
</svg>
`

if (!customElements.get('logoscorp-add-to-cart')) {
  customElements.define('logoscorp-add-to-cart', 
  class AddToCart extends HTMLElement {
    constructor() {
      super();

      this.debouncedOnChange = this.debounce((event) => {
        this.onChange(event);
      }, 300)

      this.debouncedOnFocusOut = this.debounce((event) => {
        this.onFocusOut(event);
      }, 200)

      this.changeEvent = new Event('change', { bubbles: true })

      this.input = this.querySelector('input')
      this.previousValue = this.input.value;
      this.plus_button = this.getElementsByClassName('plus_button')[0]
      this.product_quantity = this.plus_button.dataset.quantity
      if(this.input.value > 0){
        this.input.classList.remove('hidden_element')
        this.plus_button.classList.add('hidden_element')
        this.classList.add('item_in_cart')
      }

      this.addEventListener('change', this.debouncedOnChange.bind(this))
      this.addEventListener('click', this.onButtonClick.bind(this))
      this.addEventListener('focusout', this.debouncedOnFocusOut.bind(this))
      if(this.input.value == 1) this.getElementsByClassName('minus_button')[0].innerHTML = thrashIcon 
    }

    fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
      };
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }    

    onFocusOut(event){
      if (this !== document.activeElement ) {
        if(+this.input.value !== 0){
          this.plus_button.classList.add('hidden_element')
          this.classList.add('item_in_cart')
        }else{
          this.classList.remove('item_in_cart')
        }
        this.classList.add('inactive')
        this.classList.remove('active')
      }
    }

    onButtonClick(event){
      this.focus()
      const previousValue = this.input.value
      this.plus_button.classList.remove('hidden_element')
      this.classList.remove('inactive')
      if(event.target.name === 'plus'){
        if( this.product_quantity && +this.product_quantity >= this.input.value ){
          this.input.stepUp()
        }else{
          let event = new CustomEvent('document:notification', {
            detail: {
              message: "Product not in stock",
              status: "error"
            }
          })
          document.dispatchEvent(event)
        }
      }else if(event.target.name === 'minus'){
        this.input.stepDown()
      }
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      if (this.input.value == 0) { 
        this.classList.add('inactive')
      }
      this.classList.add('active')
    }

    onChange(event) {
      const key = event.target.dataset.key
      const value = event.target.value
      if(this.previousValue == 0){
        this.updateItemQuantity(key, value, routes.cart_add_url)
        this.input.value = event.target.value
        this.previousValue = this.input.value
        this.input.classList.add('hidden_element')
      }else{
        this.updateItemQuantity(key, value, routes.cart_change_url)
      }
      if(this.input.value == 1) this.getElementsByClassName('minus_button')[0].innerHTML = thrashIcon 
      if(this.input.value > 1) this.getElementsByClassName('minus_button')[0].innerHTML = minusIcon 
      this.input.value == 0 ? this.input.classList.add('hidden_element') : this.input.classList.remove('hidden_element')
    }

    updateItemQuantity(key, quantity, url){
      const body = JSON.stringify({
        id: key,
        quantity
      })
      fetch(`${url}`, { ...this.fetchConfig(), ...{ body } })
        .then((response) => { return response.json() })
        .then((state) => { 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        })
        .then(() => {
          let event = new CustomEvent('document:notification', {
            detail: {
              message: "Cart Updated",
              status: "success"
            }
          })
          document.dispatchEvent(event)
        })
    }
  });
}
